import React from 'react';
import { personalInfo } from '../data/portfolio';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer__content">
          <div className="footer__brand">
            <a href="/" className="footer__logo" aria-label={`${personalInfo.name} - Home`}>
              {personalInfo.name}
            </a>
            <p className="footer__tagline">{personalInfo.tagline}</p>
            <div className="footer__social">
              <a href={personalInfo.links.github} className="footer__social-link" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              {/* No LinkedIn or Twitter — add real ones here if you create them */}
            </div>
          </div>

          <nav className="footer__nav" aria-label="Footer navigation">
            <div className="footer__nav-group">
              <h4 className="footer__nav-title">Quick Links</h4>
              <ul className="footer__nav-list">
                <li><a href="#about" className="footer__nav-link">About Me</a></li>
                <li><a href="#skills" className="footer__nav-link">Skills</a></li>
                <li><a href="#projects" className="footer__nav-link">Projects</a></li>
                <li><a href="#experience" className="footer__nav-link">Experience</a></li>
                <li><a href="#contact" className="footer__nav-link">Contact</a></li>
              </ul>
            </div>

            <div className="footer__nav-group">
              <h4 className="footer__nav-title">Resources</h4>
              <ul className="footer__nav-list">
                <li><a href={personalInfo.resume} className="footer__nav-link" download>Resume</a></li>
                <li><a href={personalInfo.links.github} className="footer__nav-link" target="_blank" rel="noopener noreferrer">GitHub</a></li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">&copy; {currentYear} {personalInfo.name}. All rights reserved.</p>
          <p className="footer__built-with">Built with React</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
